import { render, staticRenderFns } from "./controlButton.vue?vue&type=template&id=4e420a5b"
import script from "./controlButton.vue?vue&type=script&lang=js"
export * from "./controlButton.vue?vue&type=script&lang=js"
import style0 from "./controlButton.vue?vue&type=style&index=0&id=4e420a5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports